export default "__VITE_ASSET__Mh$Sf0my__"